import { render } from "./ProjectAnalysisTools.vue?vue&type=template&id=1ba31b5a"
import script from "./ProjectAnalysisTools.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__